import { Entity } from '../../../core/context/entity';
import { UUID } from '../../../core/context/uuid/entity';
import type { ThreatPathData } from './dto';

interface ThreatPathProps {
    id: string;
    name: string;
    sourceAssetId: string;
    targetAssetId: string;
    description?: string;
    threatPathTypeId: string;
}

export class ThreatPath extends Entity {
    name: string;
    description?: string;
    sourceAssetId: string;
    targetAssetId: string;
    threatPathTypeId: string;

    constructor({
        id,
        name,
        description,
        sourceAssetId,
        targetAssetId,
        threatPathTypeId,
    }: ThreatPathProps) {
        super({ id, name });
        this.name = name;
        this.description = description;
        this.sourceAssetId = sourceAssetId;
        this.targetAssetId = targetAssetId;
        this.threatPathTypeId = threatPathTypeId;
    }

    static new({
        name,
        description,
        sourceAssetId,
        targetAssetId,
        threatPathTypeId,
    }: Omit<ThreatPathData, 'id'>): ThreatPath {
        const uuid = new UUID();

        return new ThreatPath({
            id: uuid.toString(),
            name,
            description,
            sourceAssetId,
            targetAssetId,
            threatPathTypeId,
        });
    }
}
